import { render, staticRenderFns } from "./data_report_ad.vue?vue&type=template&id=0c0c4f5e&"
import script from "./data_report_ad.vue?vue&type=script&lang=js&"
export * from "./data_report_ad.vue?vue&type=script&lang=js&"
import style0 from "./data_report_ad.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports